import { render, staticRenderFns } from "./camera-dialog.vue?vue&type=template&id=efceaa7c&scoped=true&"
import script from "./camera-dialog.vue?vue&type=script&lang=js&"
export * from "./camera-dialog.vue?vue&type=script&lang=js&"
import style0 from "./camera-dialog.vue?vue&type=style&index=0&id=efceaa7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efceaa7c",
  null
  
)

export default component.exports